module.exports = __webpack_public_path__ + "static/media/pic-svg-14.5dc6dbbe.svg";